// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2KT4S","header":"ClearentDisclaimer_header__3tBwR","inner":"ClearentDisclaimer_inner__2yBs0"};